import React, { useState, useRef } from "react";
import { Box, Typography } from "@mui/material";

// Reusable Drag-and-Drop Component
const DragAndDrop = ({
  onDrop,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onFileSelect,
  supportedFileTypes,
  uploadIcon,
  buttonLabel,
  fileInputRef,
  dropAreaStyles,
  fileInputStyles,
  handleButtonClick,
  uploadedFiles = [],
  t
}) => {
  const [dragActive, setDragActive] = useState(false);

  // Handle drag events
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  //  Function to display image or file details based on file type
   const renderFilePreview = (file) => {
    if (file.type.startsWith("image/")) {
      return (
        <Box sx={{ mb: 2 }}>
          {/* <img
            src={URL.createObjectURL(file)}
            alt={file.name}
            style={{
              maxWidth: "100px",
              maxHeight: "100px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          /> */}
        </Box>
      );
    } else {
      return (
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontWeight: 600, color: "#0F0F0F" }}>
            {file.name} ({(file.size / 1024).toFixed(2)} KB)
          </Typography>
        </Box>
      );
    }
  };

  return (
    <Box
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={onDrop}
      sx={{
        border: `2px dashed ${dragActive ? "#5E56B2" : "#BDBDBD"}`,
        borderRadius: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "50px",
        marginBottom: "20px",
        backgroundColor: "#F8F8FF",
        transition: "border-color 0.3s ease-in-out",
        ...dropAreaStyles,
      }}
    >
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <img src={uploadIcon} alt="upload-icon" style={{ marginBottom: "10px" }} />
      </Box>
      <Typography sx={{ fontWeight: 700, color: "#000", marginBottom: 1, fontSize: "24px" }}>
        {t.dragDropText}{" "}
        <label
          htmlFor="fileInput"
          style={{ color: "#5E56B2", cursor: "pointer", textDecoration: "underline" }}
          onClick={handleButtonClick}
        >
          {buttonLabel}
        </label>
      </Typography>
      <Typography sx={{ color: "#676767", fontSize: "12px", fontWeight: 400 }}>
        {/* Supported formats: {supportedFileTypes.join(", ")} */}
        {t.supportedFormats}      </Typography>
        {/* Show the selected files */}
        {uploadedFiles.length > 0 && (
        <Box sx={{ mt: 2 }}>
       
          {/* <ul style={{ listStyleType: "none", padding: 0,display:"flex" }}>
            {uploadedFiles.map((file, index) => (
              <li key={index} style={{ margin: "5px 0" }}>
                {renderFilePreview(file)}
              </li>
            ))}
          </ul> */}
        </Box>
      )}

      {/* Hidden file input */}
      <input
        type="file"
        id="fileInput"
        multiple
        style={{ display: "none", ...fileInputStyles }}
        ref={fileInputRef}
        onChange={onFileSelect}
      />
    </Box>
  );
};

export default DragAndDrop;
